import axios from 'axios'
import endpoints from '../../endpoints'
import {DriverLicenseStatusReportBase, DriverLicenseStatusReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchDriverLicenseStatusReport(
  payload: DriverLicenseStatusReportPayload
): Promise<APIResponse<DriverLicenseStatusReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.driverLicenseStatusReport, payload)
  return response.data
}
